import { useMediaQuery, queryHelpers } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import deleteAccountSuccess from 'assets/delete-account-success.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import { ModalBody } from 'components/modals/common/modal-body.component';
import { PRODUCT_AREA } from '@leagueplatform/analytics';
import { ANALYTICS_SCREEN_NAMES, ANALYTICS_DETAILS } from 'common/constants';
import { ModalActionButton } from './common/modal-action-button.component';

export const AccountDeletedModal = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      contentFooterSpacing="$twoAndHalf"
      footer={
        <ModalActionButton
          actionType="submit"
          buttonText={formatMessage({ id: 'STR_I_UNDERSTAND' })}
          isMobile={isMobile}
          css={{
            backgroundColor: '$primaryBackgroundDefault',
            alignSelf: 'flex-end',
            '&:hover': {
              backgroundColor: '$primaryBackgroundHovered',
            },
          }}
          trackAnalytics={{
            product_area: PRODUCT_AREA.SETTINGS,
            screen_name: ANALYTICS_SCREEN_NAMES.DELETION_CONFIRMATION,
            detail: ANALYTICS_DETAILS.ACKNOWLEDGE_DELETION,
          }}
        />
      }
    >
      <ModalBody
        image={deleteAccountSuccess}
        heading={formatMessage({ id: 'STR_ACCOUNT_DELETED_HEADING' })}
        paragraphs={[
          formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_1' }),
          formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_2' }),
        ]}
      />
    </BaseModalContainer>
  );
};
